var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9175 24.5835C23.1266 24.5835 24.9175 22.7926 24.9175 20.5835C24.9175 18.3744 23.1266 16.5835 20.9175 16.5835C18.7083 16.5835 16.9175 18.3744 16.9175 20.5835C16.9175 22.7926 18.7083 24.5835 20.9175 24.5835Z",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8702 2H10.9651V31H30.8702V2Z",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68052 30.9999H1.87012V8.83325H6.68052",
    stroke: "#0C101B",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9175 10.4165C21.4698 10.4165 21.9175 9.96879 21.9175 9.4165C21.9175 8.86422 21.4698 8.4165 20.9175 8.4165C20.3652 8.4165 19.9175 8.86422 19.9175 9.4165C19.9175 9.96879 20.3652 10.4165 20.9175 10.4165Z",
    fill: "#0C101B",
    stroke: "#0C101B",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakers);
export default __webpack_public_path__ + "static/media/Speakers.d435fe938c5db61bcd33c9f040de23f6.svg";
export { ForwardRef as ReactComponent };